/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {PERMISSIONS} from '../../../components/auth/auth-constants';
import {ExternalDemandSourceResource} from '../../../components/api/resources/resource/external-demand-source.resource';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-external-demand-source-route-page',
  template: `
    <adn-external-demand-source-list-page
      *ngIf="list"
      [list]="list">
    </adn-external-demand-source-list-page>
  `
})
export class ExternalDemandSourceRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(ExternalDemandSourceResource) private readonly ExternalDemandSource: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasNetwork(PERMISSIONS.manageSystem.apiKey)
      && !this.LocalUserPermissions.hasDataNetworkPermission(PERMISSIONS.dataAdmin.apiKey)
      && !this.LocalUserPermissions.hasNetworkPermission(PERMISSIONS.politicalAdmin.apiKey, null, 'POLITICAL');

    this.adnListHelper.setUpList(this.list, this.ExternalDemandSource, readOnly, 'fullExternalDemandSourceList', {
      baseTable: 'externalDemandSource'
    });
  }
}
